import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  button: {
    position: 'fixed',
    right: '24px',
    bottom: '24px',
    backgroundColor: 'white',
    border: `2px solid ${theme.palette.secondary.main}`,
    zIndex: 100,
    '&:hover': {
      backgroundColor: 'lightgrey',
    },
    '@media print': {
      display: 'none',
    },
  },
  text: {
    color: theme.palette.secondary.main,
  },
  hidden: {
    display: 'none',
  },
  show: {},
}));

export default useStyles;
